import { useState } from "react";
import "../styles/projects.css";
import QuestLog from "../projects/QuestLog.js";
import { quests } from "../projects/questData.js";

const Projects = () => {
  const [selectedQuestId, setSelectedQuestId] = useState(null);
  const [popupImage, setPopupImage] = useState(null); // 🆕 Add image popup state

  const handleSelectQuest = (id) => {
    setSelectedQuestId((prev) => (prev === id ? null : id));
  };

  const selectedQuest = quests.find((q) => q.id === selectedQuestId);

  const enhanceImagesWithClick = (node) => {
    if (!node) return null;

    if (Array.isArray(node)) {
      return node.map((child, index) => enhanceImagesWithClick(child));
    }

    if (node?.type === "img") {
      return (
        <img
          {...node.props}
          key={node.key}
          onClick={() => setPopupImage(node.props.src)}
          style={{ ...node.props.style, cursor: "pointer" }}
          alt={node.props.alt || ""}
          aria-hidden="true"
        />
      );
    }

    if (node?.props?.children) {
      return {
        ...node,
        props: {
          ...node.props,
          children: enhanceImagesWithClick(node.props.children),
        },
      };
    }

    return node;
  };

  return (
    <>
      <div className="quest-page-container">
        <div className="quest-list-panel">
          <QuestLog
            quests={quests}
            selectedQuestId={selectedQuestId}
            onSelectQuest={handleSelectQuest}
          />
        </div>

        <div className="quest-dialog-panel quest-boxes">
          {selectedQuest ? (
            <div className="quest-dialog-scroll-wrapper" key={selectedQuest.id}>
              <div className="quest-dialog-box">
                <h2>{selectedQuest.title}</h2>
                <p>{selectedQuest.subtitle}</p>
                <br />
                {enhanceImagesWithClick(selectedQuest.description)}
              </div>
            </div>
          ) : (
            <div className="quest-dialog-placeholder">
              <p>Select a quest to view more details about the project.</p>
            </div>
          )}
          <span id="questPrompt" className="dialog-prompt">▼</span>
        </div>
      </div>

      {popupImage && (
        <div
          className="image-popup-backdrop"
          onClick={() => setPopupImage(null)}
        >
          <img
            className="zoomed-image"
            src={popupImage}
            alt=""
            aria-hidden="true"
          />
        </div>
      )}
    </>
  );
};

export default Projects;
